import createIcon from '../../createIcon';

/**
 * @component @name PhoneIphone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMUg4QzYuNjIgMSA1LjUgMi4xMiA1LjUgMy41VjIwLjVDNS41IDIxLjg4IDYuNjIgMjMgOCAyM0gxNkMxNy4zOCAyMyAxOC41IDIxLjg4IDE4LjUgMjAuNVYzLjVDMTguNSAyLjEyIDE3LjM4IDEgMTYgMVpNMTIgMjJDMTEuMTcgMjIgMTAuNSAyMS4zMyAxMC41IDIwLjVDMTAuNSAxOS42NyAxMS4xNyAxOSAxMiAxOUMxMi44MyAxOSAxMy41IDE5LjY3IDEzLjUgMjAuNUMxMy41IDIxLjMzIDEyLjgzIDIyIDEyIDIyWk0xNi41IDE4SDcuNVY0SDE2LjVWMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhoneIphone = createIcon('PhoneIphone', [
  [
    'path',
    {
      d: 'M16 1H8C6.62 1 5.5 2.12 5.5 3.5V20.5C5.5 21.88 6.62 23 8 23H16C17.38 23 18.5 21.88 18.5 20.5V3.5C18.5 2.12 17.38 1 16 1ZM12 22C11.17 22 10.5 21.33 10.5 20.5C10.5 19.67 11.17 19 12 19C12.83 19 13.5 19.67 13.5 20.5C13.5 21.33 12.83 22 12 22ZM16.5 18H7.5V4H16.5V18Z',
      key: '56cpyx',
    },
  ],
]);

export default PhoneIphone;
